//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FabDrawerMenu from "@/pages/fabricInterface/components/FabDrawerMenu.vue";
import UserAccount from "@/components/UserAccount/UserAccount.vue";

export default {
    name: "MobileHeader",
    components: {
        UserAccount,
        FabDrawerMenu
    },
    props: {
        customLeftIcon: { type: Boolean, default: false }
    },
    data() {
        return {
            showModalMenu: false,
            maintenanceMsgHeight: 0
        };
    },
    watch: {
        showModalMenu: {
            handler(val) {
                if (val) {
                    const maintenanceMsgElem = document.getElementById("maintenanceMsg");
                    if (maintenanceMsgElem) {
                        this.maintenanceMsgHeight = maintenanceMsgElem.offsetHeight;
                    }
                }
                this.$emit("menuOpened", val);
            },
            immediate: true
        }
    }
};
